import { render, staticRenderFns } from "./PreparationTime.vue?vue&type=template&id=abd1e4f4&scoped=true"
import script from "./PreparationTime.vue?vue&type=script&lang=js"
export * from "./PreparationTime.vue?vue&type=script&lang=js"
import style0 from "./PreparationTime.vue?vue&type=style&index=0&id=abd1e4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd1e4f4",
  null
  
)

export default component.exports